module.exports = __webpack_public_path__ + "img/tab2.48b7df7d.png";